"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APP = void 0;
var APP;
(function (APP) {
    APP["cfchildren"] = "cfchildren";
    APP["secondstep"] = "secondstep";
    APP["learnAdmin"] = "learnAdmin";
    APP["learnMyPrograms"] = "learnMyPrograms";
    APP["learnOrphans"] = "learnOrphans";
    APP["learnMsProduct"] = "learnMsProduct";
    APP["learnHsProduct"] = "learnHsProduct";
    APP["learnK5Product"] = "learnK5Product";
    APP["learnFamilyResourcesK8"] = "learnFamilyResourcesK8";
    APP["learnFamilyResourcesHS"] = "learnFamilyResourcesHS";
})(APP || (exports.APP = APP = {}));
